<template>
    <div class="pos-fix tp-init lt-init rt-init search-box" v-show="active">
        <div class="wrapper bg-white">
            <div class="query-section pd-t-12 pd-b-12 pd-l-20 dp-fx fx-al-ct">
                <div class="dp-fx fx-al-ct fx-js-bw fx-grow-1 bg-solitude pd-t-14 pd-b-14 pd-l-20 pd-r-20 br-rd-20">
                    <input type="text" placeholder="Search movies" autocomplete="off" v-model.trim="query" @keydown.esc="resetSearchResults" @keyup="keyUp" @input="update" class="fx-grow-1 cl-black fz-14 lh-20 fw-7"/>
                    <img src="@/assets/cross.png" width=14 alt="Cross Icon" v-on:click="resetSearchResults">
                </div>
                <div class="pd-l-20 pd-r-20 pd-t-10 pd-b-10 cs-ptr" v-on:click="closeSearchBox">
                    <div class="fz-14 lh-20 fw-4 cl-blue">Cancel</div>
                </div>
            </div>
            <hr class="separation-line"/>
            <div class="results-section">
                <SearchSuggestionList :data="searchSuggestionList"/>
            </div>
        </div>
    </div>
</template>

<script>
    import VueTypeahead from "vue-typeahead";
    import SearchSuggestionList from "@/components/SearchSuggestionList.vue";

    export default {
        name : 'SearchBox',
        extends : VueTypeahead,
        props : {
            active : Boolean,
        },
        components : {
            SearchSuggestionList : SearchSuggestionList
        },
        data : function () {
            return {
                src : `https://api.themoviedb.org/3/search/movie?api_key=${process.env.VUE_APP_TMDB_APP_KEY}&page=1&include_adult=false&region=IN`,
                selectFirst : false,
                queryParamName : 'query',
                searchSuggestionList : {
                    title : '',
                    list : [],
                }
            }
        },
        methods : {
            onHit(item) {
            },

            prepareResponseData(data) {
                let results = [...data.results];
                results.sort(function (val1, val2) {
                    return val2.popularity - val1.popularity;
                });
                this.preparesearchSuggestionList(this.filterRelaventResults(results))
            },

            filterRelaventResults(results){
                return results.filter((e, i) => {
                    return ((typeof e['original_language'] !== 'undefined') && (e['original_language'] == 'hi'));
                })
            },

            preparesearchSuggestionList(list){
                let searchSuggestionList = [];
                list.forEach((e, i) => {
                    let item = {};
                    item['id'] = e['id'];
                    item['title'] = e['title'];
                    item['url'] = `/movie/${e['id']}`;
                    let bd = e['backdrop_path;'] 
                    let image = `https://image.tmdb.org/t/p/w500`;
                    if (bd == null) {
                        bd = e['poster_path'];
                        if (bd == null) {
                            bd = '';
                            image = '';
                        }
                    }
                    item['image'] = image + bd;
                    searchSuggestionList.push(item);
                });
                if (searchSuggestionList.length > 0) {
                    this.searchSuggestionList['title'] = 'Results';
                } else {
                    this.searchSuggestionList['title'] = 'No results found'
                }
                this.searchSuggestionList['list'] = searchSuggestionList;
            },

            closeSearchBox(){
                this.resetSearchResults();
                this.$emit('cancel-search-clicked');
            },

            resetSearchQuery(){
                this.query = '';
            },

            resetSearchResults(){
                this.resetSearchQuery();
                this.searchSuggestionList['title'] = '';
                this.searchSuggestionList['list'] = [];
            },

            keyUp(){
                if (this.query.length == 0) {
                    this.resetSearchResults();
                }
            }
        }
    }
</script>

<style>
    .search-box .query-section input::placeholder{
        color: #4d4d4d;
        font-size: 12px;
        line-height: 18px;
        font-weight: 400;
    }
    .search-box .separation-line{
        border-top: 1px solid #f3f3f7;
    }
    .search-box .search-suggestion-list{
        max-height: 200px;
        overflow-y: scroll;
    }
    .search-box .search-suggestion-item .img{
        width: 30px;
        height: 40px;
        background-size: cover;
        background-position: center;
        border-radius: 5px;
    }
</style>